// Screen `workflow-builder` — design/screens/WorkflowBuilder.dc.html — owner: S7.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BuilderPage } from '../../../../features/workflows/builder/BuilderPage';

const Search = z.object({
  tab: z.enum(['editor', 'runs', 'versions', 'settings']).optional().catch(undefined),
  step: z.string().max(60).optional().catch(undefined),
  // workflow-inspector: the parameter "Fix in editor" focuses (`values.stage`, `trigger.cron`).
  field: z.string().max(120).optional().catch(undefined),
});

export const Route = createFileRoute('/_focus/automations/$workflowId/')({
  validateSearch: Search,
  component: WorkflowBuilderRoute,
});

function WorkflowBuilderRoute() {
  const { workflowId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <BuilderPage
      workflowId={workflowId}
      tab={search.tab ?? 'editor'}
      step={search.step}
      onNav={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }), replace: true })}
    />
  );
}
